import { z } from 'zod';


export const PixBotCertificateItemSchema = z.object({
  id_office: z.number(),
  office_value: z.string(),
  number: z.string(),
  id_product: z.number(),
});

export const PixBotRequestSchema = z.object({
  queueName: z.string(),
  info: z.object({
    id: z.string(),
    certificates: z.array(PixBotCertificateItemSchema),
  }),
});


export const PixBotPollingResponseSchema = z.object({
  status: z.string(),
  message: z.string().optional(),
  data: z.object({
    dataResponse: z.array(
      z.object({
        outputData: z.string(),
      })
    ).optional(),
  }).optional(),
});

export const PixBotParsedDataSchema = z.object({
  data: z.array(
    z.object({
      id_office: z.number().optional(),
      matricula: z.string().optional(),
      price: z.number().optional(),
    }).passthrough()
  ),
});

export type PixBotRequest = z.infer<typeof PixBotRequestSchema>;
export type PixBotPollingResponse = z.infer<typeof PixBotPollingResponseSchema>;
